// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Periods,
} from './';

export default {
  path: 'periods',
  name: 'Periods',
  childRoutes: [
    { path: 'periods', name: 'Periods', component: Periods, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/periods/route.js